<template>
  <div v-if="element.src" :ref="refName" :class="[element.position, navId]" class="animate-layer">
    <img :src="loadFile" />
  </div>
</template>

<script>

  import { gsap } from 'gsap'  
  import * as ScrollMagic from 'scrollmagic'
  import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap"
  ScrollMagicPluginGsap(ScrollMagic, gsap )

  export default {
    name: "animateElement",
    props: {
      element: Object,
      controller: Object
    },
    mounted() {
      if(this.element.trigger) {
        this.animateElement(this.element)
      }
    },
    methods: {
      selectElement(obj) {
        return this.$refs[this.refName] ? this.$refs[this.refName] : document.querySelector(obj.name)
      },
      animateElement(obj) {
        var $this = this

        let tween = Object

        obj.element = this.selectElement(obj)

        obj.duration = obj.speed ? obj.speed : 0.2

        obj.delay = obj.delay ? obj.delay : 0
        
        if(!obj.from && obj.to)
          tween = gsap.to(
            obj.element, obj.duration, obj.to
          )

        if(!obj.to && obj.from)
          tween = gsap.from(
            obj.element, obj.duration, obj.from
          )
        
        if(obj.to && obj.from)
          tween = gsap.fromTo(
            obj.element, obj.duration, obj.from, obj.to
          )
        
        $this.addScene(tween, obj)

      },
      addScene(tween, obj) {
        const $this = this

        obj.options = {
          "triggerElement": $this.$parent.$refs[obj.trigger],
          "triggerHook": obj.hook ? obj.hook : 'onCenter'
        }

        const scene = new ScrollMagic.Scene(obj.options)
        .setTween(tween)

        if(scene)
          $this.controller.addScene(scene)
      }
    },
    computed: {
      navId() {
        return 'chapter_' + (this.element.id ? this.element.id : this.element.trigger)
      },
      loadFile() {
        if(this.element.src) {
          return require(`../assets/${this.element.src}`)
        }
        return false
      },
      refName() {
        return 'element_'+this.element.name
      }
    }
  }

</script>

<style lang="scss">

  .animate-layer {
    position: absolute;
    bottom: 0;
    right: 0;
    max-width: 675px;
    opacity: 0;
    transition: opacity .35s ease-in-out;

    @media (min-width: 200px) and (max-width: 720px) {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
      max-width: 520px;
      height: 75vh;
      opacity: 0;
      transition: opacity .35s ease-in-out;
    }

    img {
      width: auto;
      max-width: 675px;

      @media (min-width: 200px) and (max-width: 720px) {
        max-width: 100%;
      }
    }
  }

  @media (min-width: 1281px){
    .animate-layer {
      position: absolute;
      bottom: 0;
      right: 0;
      max-width: 675px;
      opacity: 0;
      transition: opacity .35s ease-in-out;

      img {
        width: auto;
        max-width: 675px;
      }
    }
  }

  @media (min-width: 721px) and (max-width: 1280px) {
    .animate-layer {
      position: absolute;
      bottom: 0;
      right: 0;
      max-width: 640px;
      opacity: 0;
      transition: opacity .35s ease-in-out;

      img {
        width: auto;
        max-width: 520px;
      }
    }
  }

</style>